import React, { FC } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface HelperProps {
    message: string;
  }

const Helper: FC<HelperProps> = ({message}) => {

    return(           
            <FontAwesomeIcon icon={faQuestionCircle} size="1x" color="#98A2B2" title={message} style={{marginLeft: "5px"}}/>
                   
    );
};

export default Helper;